{/*import { Link } from 'react-router-dom';*/ }

{/*import { PATHS } from '@/constants/page-paths';*/ }
import CountUp from 'react-countup';
import { useAuth } from '@/lib/hooks/useAuth';
import { AiOutlinePlus } from 'react-icons/ai';
import { ProfileDropdown } from '../../ProfileDropdown';
import { Web3Wallet } from '@/components/shared/web3-wallet/web3-wallet';
import { Skeleton } from '@/components/ui/skeleton';
import { useWalletBalance } from '@/lib/hooks/web3/useWalletBalance';
import TwinCoin from '@/pages/buy-points/components/TwinCoin';
import { TextToolTip } from '@/components/shared/TextToolTip';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { MobileMenu } from './MobileMenu';

export const RightNav = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { isLoading, points } = useWalletBalance()

  return (
    <div className="flex items-center justify-between gap-2 md:gap-6 h-full">
      {isAuthenticated ? (
        <>
          {isLoading ? (
            <Skeleton className="w-20 h-6" />
          ) : (
            <div className="flex justify-center items-center px-2 py-1 gap-1 sm:gap-2 rounded-full bg-secondary text-secondary-foreground">
              <div className="flex gap-1 items-center sm:gap-2">
                <TwinCoin />
                <div className="font-semibold text-sm">
                  <CountUp
                    end={parseFloat(points) as unknown as number}
                    decimals={0}
                    duration={0.5}
                  />
                </div>
              </div>
              <span>
                <TextToolTip label="Buy Points" side="bottom">
                  <Button
                    onClick={() => navigate('/buy-points')}
                    className="h-6 w-6 px-1 rounded-full"
                    data-testid="buy-point-button-right-nav"
                  >
                    <AiOutlinePlus />
                  </Button>
                </TextToolTip>
              </span>
            </div>
          )}
          <div className="hidden sm:block">
            <Web3Wallet />
          </div>
          <div className="hidden lg:block">
            <ProfileDropdown />
          </div>
          <MobileMenu />
        </>
      ) : (
        <div
          className="flex items-center gap-2 md:gap-4"
          data-testid="sign-in-right-nav"
        >
          <MobileMenu />
          {/* <Link to={PATHS.SIGN_UP}>Sign-up</Link>  */}
        </div>
      )}
    </div>
  );
};
